import { defineProperty as _defineProperty, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { standardButtonHover } from '../../components/button/variants.esm.js';
import { THEME_UI_DEFAULT_KEY } from '../../theme-provider/types.esm.js';
import { omit } from '../../utils/object.esm.js';

var _anchors;
var standardAnchor = {
  color: 'inherit',
  bg: 'transparent',
  cursor: 'pointer',
  p: 'unset',
  textDecoration: 'none',
  '&.is-disabled': {
    pointerEvents: 'none'
  }
};
var defaultDisable = {
  '&.is-disabled': {
    color: 'neutral.medium',
    cursor: 'default'
  }
};
var anchorUnderlineHover = {
  textDecoration: 'underline'
};
var hoverAnchor = {
  '&:hover:not(.is-disabled):not(.is-toggled):not(.disable-hover)': {
    textDecoration: 'underline',
    opacity: 1,
    cursor: 'pointer'
  }
};
var hover = {
  '&:hover:not(.is-disabled):not(.is-toggled):not(.disable-hover), &:active:not(.is-disabled):not(.is-toggled):not(.disable-hover)': {
    textDecoration: 'underline',
    opacity: 1,
    cursor: 'pointer',
    color: 'primary' //prevent global overwrite
  }
};
var anchors = (_anchors = {}, _defineProperty(_anchors, THEME_UI_DEFAULT_KEY, _objectSpread2(_objectSpread2({}, standardAnchor), {}, {
  '&:hover:not(.is-disabled):not(.is-toggled):not(.disable-hover)': {
    opacity: '0.6'
  }
})), _defineProperty(_anchors, "underline", _objectSpread2(_objectSpread2({}, standardAnchor), hover)), _defineProperty(_anchors, 'no-hover', standardAnchor), _defineProperty(_anchors, 'hover-primary', _objectSpread2(_objectSpread2({}, standardAnchor), {}, {
  '&:hover:not(.is-disabled):not(.is-toggled):not(.disable-hover)': {
    opacity: '0.6',
    color: 'primary'
  }
}, defaultDisable)), _defineProperty(_anchors, 'text-button', function textButton(theme) {
  return _objectSpread2(_objectSpread2({}, omit(standardAnchor, ['p'])), {}, {
    border: 'black',
    borderRadius: 'default',
    '&:hover:not(.is-disabled):not(.is-toggled):not(.disable-hover)': standardButtonHover(theme)
  });
}), _defineProperty(_anchors, 'primary-button', function primaryButton(theme) {
  return _objectSpread2(_objectSpread2({}, omit(standardAnchor, ['p', 'bg'])), {}, {
    bg: 'primary',
    border: 'primary',
    color: 'white',
    borderRadius: 'default',
    '&:hover:not(.is-disabled):not(.is-toggled):not(.disable-hover)': _objectSpread2(_objectSpread2({}, standardButtonHover(theme)), {}, {
      color: 'white'
    })
  });
}), _defineProperty(_anchors, "primary", _objectSpread2(_objectSpread2({
  color: 'primary',
  fontWeight: 'bold'
}, hoverAnchor), defaultDisable)), _defineProperty(_anchors, 'primary-icon', _objectSpread2({
  color: 'primary',
  fontWeight: 'bold',
  '&:hover:not(.is-disabled):not(.is-toggled):not(.disable-hover)': {
    opacity: 0.6,
    cursor: 'pointer'
  }
}, defaultDisable)), _defineProperty(_anchors, "secondary", _objectSpread2({}, hoverAnchor)), _anchors);

export { anchorUnderlineHover, anchors, hover, hoverAnchor, standardAnchor };
//# sourceMappingURL=anchors.esm.js.map
